import { call, put } from 'redux-saga/effects';

import { convertArrToObj } from '../../utils';
import { sagaErrorHandle } from './sagasError';
import {
  listAllRequest,
  listByLessonRequest,
  storeRequest,
  updateRequest,
  removeRequest,
} from '../../services/annotations';

import { AnnotationsTypes as Types } from '../ducks/annotations';
import { CourseTypes } from '../ducks/course';

export function* listAllAnnotations() {
  yield put({ type: Types.SET_ANNOTATIONS_FAILURE, errorData: null });
  try {
    const { data } = yield call(listAllRequest);
    const annotations = data.length ? convertArrToObj(data, 'id') : {};
    yield put({ type: Types.SET_ANNOTATIONS, annotations });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'listAllAnnotations',
      errorData: error,
    });
    yield put({
      type: Types.SET_ANNOTATIONS_FAILURE,
      errorData: { status, msg },
    });
  }
}

export function* listByLessonAnnotations({ courseId, lessonId }) {
  try {
    const { data } = yield call(listByLessonRequest, { courseId, lessonId });
    const annotations = data.length > 0 ? convertArrToObj(data, 'id') : {};
    yield put({ type: Types.UPDATE_ANNOTATIONS, annotations });
    yield put({
      type: CourseTypes.UPDATE_LESSON_ANNOTATIONS_STATUS,
      status: true,
      course: courseId,
      lesson: lessonId,
    });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'listByLessonAnnotations',
      errorData: error,
      checkValidAuthentication: true,
      additionalInfos: { courseId, lessonId },
    });
    yield put({
      type: Types.SET_ANNOTATIONS_FAILURE,
      errorData: { status, msg, courseId, lessonId },
    });
    yield put({
      type: CourseTypes.UPDATE_LESSON_ANNOTATIONS_STATUS,
      status: false,
      course: courseId,
      lesson: lessonId,
    });
  }
}

export function* storeAnnotation(action) {
  const { courseId, lessonId, description } = action;
  const annotationData = {
    description,
    isActive: true,
  };

  try {
    const { data } = yield call(storeRequest, {
      courseId,
      lessonId,
      annotationData,
    });
    const annotations = { [data.id]: data };
    yield put({ type: Types.UPDATE_ANNOTATIONS, annotations });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'storeAnnotation',
      errorData: error,
      additionalInfos: action,
    });
    yield put({
      type: Types.SET_ANNOTATIONS_FAILURE,
      errorData: { status, msg },
    });
  }
}

export function* updateAnnotation(action) {
  const { courseId, lessonId, annotationId, description } = action;
  const annotationData = {
    description,
    isActive: true,
  };

  try {
    const { data } = yield call(updateRequest, {
      courseId,
      lessonId,
      annotationId,
      annotationData,
    });
    const annotations = { [data.id]: data };
    yield put({ type: Types.UPDATE_ANNOTATIONS, annotations });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'updateAnnotation',
      errorData: error,
      additionalInfos: action,
    });
    yield put({
      type: Types.SET_ANNOTATIONS_FAILURE,
      errorData: { status, msg },
    });
  }
}

export function* removeAnnotation(action) {
  const { courseId, lessonId, annotationId } = action;
  try {
    yield call(removeRequest, { courseId, lessonId, annotationId });
    yield put({ type: Types.REMOVE_ANNOTATION, annotationId });
  } catch (error) {
    const { status, message: msg } = yield sagaErrorHandle({
      sagaName: 'removeAnnotation',
      errorData: error,
      additionalInfos: action,
    });
    yield put({
      type: Types.SET_ANNOTATIONS_FAILURE,
      errorData: { status, msg },
    });
  }
}
